/* @flow */
// typecheck: ignore file
import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Tabs from 'components/Tabs.jsx';
import TabPanel from 'components/TabPanel.jsx';
import Link from 'components/Link.jsx';
import Glyph from 'components/Glyph.jsx';
import Text from 'components/Text.jsx';

import './styles/SchoolLayout.scss';

type Props = {
  children: any,
  params: any,
  paid: ?boolean,
  isParentAdmin: ?boolean,
  parentId: ?number,
  loading: boolean,
};

class SchoolLayout extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  goPeoples = () => {
    this.context.router.push(`/admin/schools/${this.props.params.schoolId}/information`);
  }

  goBilling = () => {
    this.context.router.push(`/admin/schools/${this.props.params.schoolId}/billing`);
  }

  onTabChange = (index: number) => {
    [this.goPeoples, this.goBilling][index]();
  }

  render() {
    const { loading, paid, isParentAdmin, parentId } = this.props;
    const informations = !!this.context.router.location.pathname.match(/schools\/[0-9]+\/information/);

    // district admin cant access billing at school level, we show "go back" instead
    const shouldSeeGoBack = !loading && isParentAdmin && parentId;
    const shouldSeeTabs = paid && !shouldSeeGoBack;

    return (
      <div className="SchoolLayout">
        {shouldSeeGoBack &&
          <Text size="xxxsmall" className="SchoolLayout-goBack">
            <Link to={`/admin/districts/${parentId || ''}`}>
              <Glyph name="arrow-left" /> Back to schools
            </Link>
          </Text>
        }
        {shouldSeeTabs &&
          <div className="SchoolLayout-tabs">
            <Tabs tabActive={informations ? 0 : 1} onTabChange={this.onTabChange}>
              <TabPanel title={<span>Your school</span>} />
              <TabPanel title={<span>Billing</span>} />
            </Tabs>
          </div>
        }
        {this.props.children}
      </div>
    );
  }
}

const withOrganization = graphql(gql`
  query($organizationId: Int) {
    organizations(ids: [$organizationId]) {
      id
      paid
      parent_id
      is_parent_org_admin
    }
  }`,
  {
    options: ({ params }) => ({
      variables: { organizationId: [params.schoolId] },
    }),
    props: ({ data }) => ({
      paid: data.organizations ? data.organizations[0].paid : null,
      isParentAdmin: data.organizations ? data.organizations[0].is_parent_org_admin : null,
      parentId: data.organizations ? data.organizations[0].parent_id : null,
      loading: data.loading,
    }),
  }
);

export { SchoolLayout };
export default withOrganization(SchoolLayout);



// WEBPACK FOOTER //
// ./src/admin/components/SchoolLayout.jsx